import { ISearchable } from './Searchable.itf'
/**
* @typedef  PoissonTailleConstructor
* @type {object}
* @property {Object} idTaille - the idTaille value
* @property {string} taille - the taille value
* @author generator-sqlite
* */
export class PoissonTaille extends ISearchable {
  /**
   * Creates an instance of PoissonTaille.
   * @param {PoissonTailleConstructor} object.idAchats
   * @memberof PoissonTaille
   * @author generator-sqlite
   * */
  constructor(object) {
    super()
    this.idTaille = object.idTaille
    this.taille = object.taille
  }

  formatToDisplay() {
    this.lineClassName = 'sizeLine'
    this.boxClassName = 'sizeBox'
    this.displayType = 'Taille'
    this.raccourci = this.taille
    this.nom = this.taille
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-sizeLine'
    return this
  }

  getIdAttribute() {
    return 'idTaille'
  }

  getNameAttribute() {
    return 'taille'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
